'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 25, height: 25, viewBox: "0 0 25 25", fill: "none" }, props),
    React__namespace.createElement("circle", { cx: 12.996, cy: 12.992, r: 12, fill: "#02060C", fillOpacity: 0.15 }),
    React__namespace.createElement("g", { clipPath: "url(#24_svg__clip0_39877_64452)" },
        React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.176 8.899a.9.9 0 0 0-1.273 1.272l2.82 2.821-2.82 2.82a.9.9 0 0 0 1.273 1.274l2.82-2.821 2.821 2.82a.9.9 0 0 0 1.273-1.272l-2.82-2.82 2.82-2.822A.9.9 0 1 0 15.817 8.9l-2.82 2.82z", fill: "white" })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "24_svg__clip0_39877_64452" },
            React__namespace.createElement("rect", { width: 9.996, height: 9.996, fill: "white", transform: "translate(7.998 7.994)" })))));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
